import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    user: null,
    token: null,
    refreshToken: null,
    refreshTokenExp: 0,
    exp: 0, // Token expiration time in seconds (UTC) from token
    roles: [],
    permissions: [],
    routeMeta: {},
    remember: false,

    identities: [],
    activeIdentityId: null,
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    user: (state) => state.user,

    token: (state) => state.token,
    refreshToken: (state) => state.refreshToken,

    tokenValid: (state) => (offsetSecs = 0) => state.token && (state.exp - offsetSecs > new Date().getTime() / 1000),
    refreshTokenValid: (state) => (offsetSecs = 0) => {
      return state.refreshToken && (state.refreshTokenExp - offsetSecs > new Date().getTime() / 1000);
    },

    roles: (state) => state.roles,
    permissions: (state) => state.permissions,

    isLoggedIn: (state) => {
      return state.exp > new Date().getTime() / 1000
        || (state.refreshToken && state.refreshTokenExp.exp > new Date().getTime() / 1000);
    },

    identities: (state) => {
      return state.identities;
    },

    identity: (state) => (id) => state.identities.find((i) => i.id === id),

    activeIdentity: (state, getters) => {
      return state.identities.find((i) => i.id === state.activeIdentityId);
    },

  },
  mutations,
  actions,
};

export { store, defaultState };
